import React from 'react';
import { Select, SelectProps } from '@economic/taco';
import { t } from '@lingui/macro';

export default function DebitCreditDropdown(props: SelectProps) {
    return (
        <Select
            {...props}
            className="w-24"
            data={[
                {
                    text: t`Debit`,
                    value: false,
                },
                {
                    text: t`Credit`,
                    value: true,
                },
            ]}
        />
    );
}
